import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistReducer } from 'redux-persist';
import persistStorage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import banner from './banner/banner.slice';
import tracking from './tracking/tracking.slice';
import rootSaga from '../saga';

const sagaMiddleware = createSagaMiddleware();

export const history = createBrowserHistory();

const persistConfig = {
  key: 'root',
  whitelist: [] as string[],
  storage: persistStorage,
};

const trackingConfig = {
  key: 'tracking',
  whitelist: ['token', 'pickitCode'],
  storage: persistStorage,
};

const rootReducer = combineReducers({
  router: connectRouter(history),
  banner,
  tracking: persistReducer(trackingConfig, tracking),
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Se crea el store de redux y configura automáticamente la extensión Redux DevTools
export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    })
      .concat(sagaMiddleware)
      .concat(routerMiddleware(history)),
});

// Se inicia el middleware de saga
sagaMiddleware.run(rootSaga);

// Se infiere el `RootState` y `AppDispatch` directamente desde la store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
